import React from 'react';
import { Breakpoint } from '@moda/om';
import { Order, OrderItem } from '../../hooks/useOrder';
import { AccountOrderHeaderDesktop } from './AccountOrderHeaderDesktop';
import { AccountOrderHeaderMobile } from './AccountOrderHeaderMobile';

interface Props {
  order: Order;
  categoryName: string;
  showShipping: boolean;
  showOrderTotal: boolean;
  showRemainingBalance: boolean;
  showPayRemainingBalance: boolean;
  orderItems?: OrderItem[] | undefined;
}

export const AccountOrderHeader: React.FC<Props> = ({
  order,
  categoryName,
  showShipping,
  showOrderTotal,
  showRemainingBalance,
  showPayRemainingBalance,
  orderItems
}) => {
  return (
    <>
      <Breakpoint gt="sm">
        <AccountOrderHeaderDesktop
          order={order}
          showShipping={showShipping}
          showOrderTotal={showOrderTotal}
          showRemainingBalance={showRemainingBalance}
          showPayRemainingBalance={showPayRemainingBalance}
          categoryName={categoryName}
          orderItems={orderItems}
        />
      </Breakpoint>

      <Breakpoint lt="sm">
        <AccountOrderHeaderMobile
          order={order}
          showShipping={showShipping}
          showOrderTotal={showOrderTotal}
          showRemainingBalance={showRemainingBalance}
          showPayRemainingBalance={showPayRemainingBalance}
          categoryName={categoryName}
          orderItems={orderItems}
        />
      </Breakpoint>
    </>
  );
};
